import { useCallback } from 'react';
import { useTimezoneFormatter } from './useTimezoneFormatter';
import { orgDayKey, orgDayRange, orgToday, type EpochMs, type InstantInput } from '@/utils/orgCalendar';

export const useOrgCalendar = () => {
  const { timezone, isOrgTimezone } = useTimezoneFormatter();

  const dayKey = useCallback((instant: InstantInput) => orgDayKey(instant, timezone), [timezone]);
  const today = useCallback((now: EpochMs) => orgToday(timezone, now), [timezone]);
  const dayRange = useCallback((days: number, now: EpochMs) => orgDayRange({ timezone, days, now }), [timezone]);

  return { timezone, isOrgTimezone, dayKey, today, dayRange };
};
